import { render, staticRenderFns } from "./EditUrban.vue?vue&type=template&id=19bed742&"
import script from "./EditUrban.vue?vue&type=script&lang=js&"
export * from "./EditUrban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports